var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.XerZenomoLayout,{attrs:{"hide-navbar":true}},[_c('div',{staticClass:"xer-flex xer-justify-center"},[_c(_setup.XerLoading)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }